import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { BeneMobile } from '../../../models/bene-mobile/bene-mobile';
import { BeniMobiliResponse } from '../../../models/dto/beni-mobili-response';
import { SezioneBeniMobili } from '../../../models/sezioni/sezione-beni-mobili';
import { FormValidationService } from '../../../services/form-validation.service';
import { BeniMobiliFormComponent } from '../../../form/beni-mobili-form.component';

@Component({
    selector: 'div [beni-mobili-form-update]',
  templateUrl: '../../../form/beni-mobili-form.html'
})
export class BeniMobiliUpdateComponent extends BeniMobiliFormComponent implements OnInit {
  urlUpdateBene: string;
  idSezione: string;
  beneMobile: BeneMobile;

  @Output()
    onReturn: EventEmitter<SezioneBeniMobili> = new EventEmitter<SezioneBeniMobili>();

  constructor(@Inject(OperationsService) operationService: OperationsService,
              @Inject(FormBuilder) campiForm,
              @Inject(HelpersService) helpers: HelpersService,
              @Inject(FormValidationService) formValidationService: FormValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica bene pignorato - mobile');
    this.isInserimento(false);
  }

  getBeneMobile(): BeneMobile {
    return this.beneMobile;
  }

  getRequest(beneMobile: BeneMobile) {
    this.operationService.updateBeneMobile(this.urlUpdateBene, this.idSezione, beneMobile).subscribe(response => this.beneMobileUpdated(response));
  }

  beneMobileUpdated(response: BeniMobiliResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(beneMobile: BeneMobile, urlUpdateBene: string, idSezione: string) {
    this.beneMobile = beneMobile;
    this.urlUpdateBene = urlUpdateBene;
    this.idSezione = idSezione;
    this.populateSelect();
    this.createForm();
  }
}
